import { Link } from "wouter";
import type { InsightsEvidence } from "@shared/cashInsights";
import { cashDate, cashNumber, useCashLanguage } from "./cashWorkbench";

/** Read-only normalized evidence for records that are not cash movements. */
export function InsightsEvidenceDetails({ evidence: r }: { evidence: InsightsEvidence }) {
  const { ar, text } = useCashLanguage();
  const fallback = text("Not recorded", "غير مسجل");
  const fields: [string, string | number | null | undefined][] = [
    [text("Reference", "المرجع"), r.reference],
    [text("Cash book reference", "مرجع دفتر النقدية"), r.cashBookReference],
    [text("Date", "التاريخ"), cashDate(r.date)],
    [text("Branch", "الفرع"), r.branch],
    [text("Record type", "نوع السجل"), r.entryType || r.kind],
    [text("Amount (EGP)", "المبلغ (ج.م)"), cashNumber(r.amount)],
    [text("Line item", "البند"), ar ? r.itemAr || r.item : r.item || r.itemAr],
    [text("Category", "الفئة"), ar ? r.categoryAr || r.category : r.category || r.categoryAr],
    [text("Item code", "كود البند"), r.code],
    [text("Shop / Supplier", "المحل / المورد"), r.supplier],
    [text("Recorded by", "مسجل بواسطة"), r.recordedByName],
    [text("Receipt reference", "مرجع الإيصال"), r.receiptId],
    [text("Entry reference", "مرجع القيد"), r.entryId],
    [text("Settlement reference", "مرجع التسوية"), r.settlementId],
    [text("Opened", "وقت الفتح"), r.openedAt ? new Date(r.openedAt).toLocaleString(ar ? "ar-EG" : "en-GB", { timeZone: "Africa/Cairo" }) : null],
    [text("Closed", "وقت الإغلاق"), r.closedAt ? new Date(r.closedAt).toLocaleString(ar ? "ar-EG" : "en-GB", { timeZone: "Africa/Cairo" }) : null],
    [text("Duration (days; not money)", "المدة (أيام، وليست مبلغاً)"), r.durationHours == null ? null : cashNumber(r.durationHours / 24)],
  ];
  return <div dir={ar ? "rtl" : "ltr"}>
    <p className="cb-notice">{text("Read-only source evidence. This record is not a cash movement; cash-book editing actions do not apply.", "أدلة المصدر للقراءة فقط. هذا السجل ليس حركة نقدية، ولا تنطبق عليه إجراءات تعديل دفتر النقدية.")}</p>
    <div className="cb-detail-grid">{fields.map(([label, value]) => <div key={label}><small>{label}</small><b translate="no">{value == null || value === "" ? fallback : <bdi>{value}</bdi>}</b></div>)}</div>
    <div className="cb-form-footer">{r.path ? <Link className="cb-btn" href={r.path} target="_blank" rel="noopener noreferrer">{text("Open original source in new tab", "فتح المصدر الأصلي في تبويب جديد")}</Link> : <p className="cb-muted">{text("No original source link was supplied.", "لم يتم توفير رابط للمصدر الأصلي.")}</p>}</div>
  </div>;
}
